
import { Component, Prop, Vue } from 'vue-property-decorator';
import VideoPlayerSource from '@/app_code/VideoPlayerSource';

@Component
export default class VideoBanner extends Vue {
}
